import { setupENS } from '@ensdomains/ui'
import { isENSReadyReactive } from '../reactiveVars'

const LLAMA_NODES_URL = process.env.REACT_APP_LLAMA_NODES_URL

let ens = {},
  registrar = {},
  ensRegistryAddress = undefined

export async function setup({
  enforceReadOnly,
  enforceReload,
  customProvider,
  ensAddress
}) {
  let option = {
    reloadOnAccountsChange: false,
    enforceReadOnly,
    enforceReload,
    customProvider,
    ensAddress,
    infura: false
  }
  if (enforceReadOnly) {
    option.llama = LLAMA_NODES_URL
  }
  const {
    ens: ensInstance,
    registrar: registrarInstance,
    providerObject
  } = await setupENS(option)
  ens = ensInstance
  registrar = registrarInstance
  ensRegistryAddress = ensAddress
  isENSReadyReactive(true)
  return { ens, registrar, providerObject }
}

export function getRegistrar() {
  return registrar
}

export function getEnsAddress() {
  return ensRegistryAddress
}

export default function getENS() {
  return ens
}
